/**
 * The noria (water wheel) SVG — a spinning wheel of buckets on an A-frame over
 * a trough, dripping water. Used both on the live board and in the reveal.
 */
export function noriaSVG(): string {
  const cx = 50, cy = 46, rimR = 40, hubR = 8, nb = 8;
  let spokes = "", buckets = "";
  for (let i = 0; i < nb; i++) {
    const a = i * (Math.PI * 2 / nb);
    const x = cx + Math.cos(a) * rimR, y = cy + Math.sin(a) * rimR;
    spokes += `<line x1="${cx}" y1="${cy}" x2="${x.toFixed(1)}" y2="${y.toFixed(1)}"/>`;
    const bw = 11, bh = 8, deg = (a * 180 / Math.PI + 90).toFixed(1);
    buckets += `<g transform="translate(${x.toFixed(1)} ${y.toFixed(1)}) rotate(${deg})"><rect x="${-bw / 2}" y="${-bh / 2}" width="${bw}" height="${bh}" rx="2.5" class="bucket"/></g>`;
  }
  return `<svg viewBox="0 0 100 104" class="noria-svg">
    <line class="frame" x1="50" y1="46" x2="22" y2="98"/>
    <line class="frame" x1="50" y1="46" x2="78" y2="98"/>
    <rect class="trough" x="13" y="96" width="74" height="8" rx="3"/>
    <g class="wheelspin">
      <circle class="rim" cx="${cx}" cy="${cy}" r="${rimR}"/>
      <circle class="rim2" cx="${cx}" cy="${cy}" r="${rimR - 6}"/>
      <g class="spokes">${spokes}</g>
      <g class="buckets">${buckets}</g>
      <circle class="hub" cx="${cx}" cy="${cy}" r="${hubR}"/>
    </g>
    <circle class="drop d1" cx="80" cy="60" r="2.6"/>
    <circle class="drop d2" cx="85" cy="66" r="2"/>
    <circle class="drop d3" cx="77" cy="64" r="1.8"/>
  </svg>`;
}

/** Build a positioned noria element (optionally ghost/preview styled). */
export function makeNoriaEl(extraClass?: string): HTMLDivElement {
  const d = document.createElement("div");
  d.className = "noria" + (extraClass ? " " + extraClass : "");
  d.innerHTML = noriaSVG();
  return d;
}
